import { render } from "./CambiarContrasena.vue?vue&type=template&id=6158abf8&scoped=true"
import script from "./CambiarContrasena.vue?vue&type=script&lang=js"
export * from "./CambiarContrasena.vue?vue&type=script&lang=js"

import "./CambiarContrasena.vue?vue&type=style&index=0&id=6158abf8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6158abf8"]])

export default __exports__